import debugLog from '@/debug-log-script-name.js'
;(function($) {
  const $body = $('body')
  const $modal = $('#briq-modal')
  debugLog($modal, 'briq-modal.js')
  $modal
    .on('show.bs.modal', function(e) {
      const $modal = $(this)
      const $relatedTarget = $(e.relatedTarget)
      const url = $relatedTarget.attr('data-url')
      $modal.find('.modal__body').html('Loading...')
      if (url && url !== '#') {
        $.ajax(url, {
          dataType: 'json',
        }).then(
          function(value) {
            $modal.find('.modal__body').html(value.html)
            $modal.trigger('bless')
            $body.trigger({ type: 'modal.content', modal: $modal })
          },
          function() {
            console.error('Failed to fetch modal content')
          },
        )
        $body.trigger({ type: 'modal.show', modal: $modal })
      } else {
        console.warn(
          'show.bs.modal was triggered but relatedTarget did not have a valid url attribute',
        )
      }
    })
    .on('shown.bs.modal', function(e) {
      $body.trigger({ type: 'modal.shown', modal: $(this) })
    })
    .on('hidden.bs.modal', function(e) {
      $body.trigger({ type: 'modal.hidden', modal: $(this) })
    })
})(jQuery)
